import { Component, ViewChild, Input, OnInit, ViewEncapsulation, Output, EventEmitter, Renderer } from '@angular/core';
import { PostitModel } from '../../models/postit.model';
import { Router } from '@angular/router';
import { SmsService } from '../../services/sms.service';
import { PostitService } from '../../services/postit.service';

@Component({
    selector     : 'my-postit',
    template: require('./postit.component.html'),
    styles: [require('./postit.component.scss')],
    encapsulation: ViewEncapsulation.None
})

export class PostitComponent implements OnInit {

    @Input('postit') postit: PostitModel;
    @ViewChild('text') text;
    @Output() eventDelete: EventEmitter<string> = new EventEmitter<string>();

    public functionClick: any[]       = [];

    constructor(private renderer: Renderer, private router: Router, private smsService: SmsService, private postitService: PostitService) {

    }

    modelChange(_event) {
        //this.postit.contentScreen = this.text.nativeElement.innerHTML;
        this.postit.customer = null;
        this.postit.modalChange(this.text);
        this.addEventOnCustomer();
    }

    ngOnInit() {
        this.postit.view = this;
        this.text.nativeElement.innerHTML = this.postit.contentScreen;
        this.addEventOnCustomer();
    }

    addCustomer() {
        this.text.nativeElement.innerHTML = this.text.nativeElement.innerHTML + ' @';
        this.text.nativeElement.focus();
        this.placeCaretAtEnd(this.text.nativeElement);
        this.postit.search = ' ';
        this.addEventOnCustomer();
        this.postitService.isOpen = true;
    }

    close(){
        this.postit.customer=null;
        this.postitService.isOpen = false;
    }

    public addEventOnCustomer() {
        //remove last event
        this.functionClick.forEach((e)=> {
            e();
        });
        this.functionClick = [];
        //add event
        for (let i = 0; i < this.text.nativeElement.children.length; i++) {
            this.functionClick.push(this.renderer.listen(this.text.nativeElement.children[i], 'click', (_evt)=> {
                this.postit.customers.forEach((customer)=> {
                    if (customer.privateId == _evt.srcElement.id || customer._id == _evt.srcElement.id)
                        if (!this.postit.search) {
                            this.postit.customer      = customer;
                            this.postitService.isOpen = true;
                        }
                });
            }));
        }
    }

    closeCustomer() {
        if (this.postit.customer)
            this.postit.customer = null;
    }

    placeCaretAtEnd(el) {
        el.focus();
        if (typeof window.getSelection != "undefined"
            && typeof document.createRange != "undefined") {
            let range = document.createRange();
            range.selectNodeContents(el);
            range.collapse(false);
            let sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
        }
    }

    sendSMS(customer) {
        let id = '';
        if (customer._id)
            id = customer._id;
        if (customer.privateId)
            id = customer.privateId;
        this.smsService.open(id, customer.mobile, customer.lastName + ' ' + customer.firstName, 'postit', this.postit.privateId);
    }

    navigateCustomer(customer) {
        this.postitService.isOpen = false;
        this.postit.customer = null;
        if (customer._id)
            this.router.navigate(['customer', customer._id]);
        if (customer.privateId)
            this.router.navigate(['customer', customer.privateId]);
    }

    delete() {
        this.postit.delete();
        this.eventDelete.emit(this.postit.privateId);
    }

    unDelete() {
        this.postit.unDelete();
        this.eventDelete.emit(this.postit.privateId);
    }

    clickBack(){
        if (this.postit.search){
            let regex = /(^| |&nbsp;|\n|>)@(([^\W]+)?( )?([^\W]+))/g;
            this.postit.contentScreen = this.postit.contentScreen.replace(regex, '');
            this.postit.refresh();
            this.postit.search = '';
            this.addEventOnCustomer();
            this.postit.screenToContent();
            if (this.postit.privateId)
                this.postit.update();
            else
                this.postit.create();
        }
        this.postit.customer=null;
        this.postitService.isOpen = false;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/components/postit/postit.component.ts